import React from 'react';
import PropTypes from 'prop-types';

import { VISUALISATION_TYPES } from 'utils/constants/visualisationTypes';

import VisualisationThumbnail from './VisualisationThumbnail';
import { thumbnails } from './thumbnails';
import { StyledWrapper, StyledTitle } from './styles';

const { LOCATION, HEATMAP, CHOROPLETH } = VISUALISATION_TYPES;

const VisualisationType = ({ visualizationType, onChangeVisualizationType, aggregates }) => {
  const handleOnChangeVisualizationType = ({ target }) => onChangeVisualizationType(target.value);
  const canSelectChoropleth = aggregates.length > 0;

  return (
    <>
      <StyledTitle>Visualisation Type</StyledTitle>
      <fieldset onChange={handleOnChangeVisualizationType}>
        <StyledWrapper>
          {thumbnails({ canSelectChoropleth }).map(({
            id,
            title,
            text,
            imageSrc,
            disabled,
            type,
          }) => (
            <VisualisationThumbnail
              key={id}
              type={type}
              text={text}
              title={title}
              disabled={disabled}
              imageSrc={imageSrc}
              selected={type === visualizationType}
            />
          ))}
        </StyledWrapper>
      </fieldset>
    </>
  );
};

VisualisationType.propTypes = {
  aggregates: PropTypes.array.isRequired,
  onChangeVisualizationType: PropTypes.func.isRequired,
  visualizationType: PropTypes.oneOf([LOCATION, HEATMAP, CHOROPLETH]).isRequired,
};

export default React.memo(VisualisationType);
